import { render, staticRenderFns } from "./VideoPlayer.vue?vue&type=template&id=38bc072a&scoped=true&lang=pug"
import script from "./VideoPlayer.vue?vue&type=script&lang=ts"
export * from "./VideoPlayer.vue?vue&type=script&lang=ts"
import style0 from "./VideoPlayer.vue?vue&type=style&index=0&id=38bc072a&prod&lang=scss"
import style1 from "./VideoPlayer.vue?vue&type=style&index=1&id=38bc072a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38bc072a",
  null
  
)

export default component.exports